'use es6';

import PortalIdParser from 'PortalIdParser';
export var getTrialGuideUrl = function getTrialGuideUrl(upgradeProduct) {
  return "/trial-guide/" + PortalIdParser.get() + "/" + upgradeProduct;
};
export var getReportsDashboardUrl = function getReportsDashboardUrl() {
  return "/reports-dashboard/" + PortalIdParser.get() + "/sales";
};